jQuery(document).ready(function ($) {
  const $productThumbTemplate = $('#product-thumb-template');
  const $loading = $('.loading');
  const $btnLoadMore = $('.js-btn-load-more');

  if ($productThumbTemplate.length === 0) return false;

  const productThumbTemplateHTML = $productThumbTemplate.html();

  let currentPage = 1;
  let PRODUCTS_PER_PAGE = 12;
  let clickedOption = $('.line-container').data('title');

  $('.line-container').hide();

  const initialize = () => {
    attachEvents();
    renderCarousels();

    $('.line-container:first').show();
  };

  const attachEvents = () => {
    $('#performance-filter #first-option').on('click', function () {
      $('#first-option').toggleClass('first-option-opened');
      $('.select-option').toggleClass('select-option-opened');
      $('#performance-filter-list').toggleClass('show');
    });

    $('.select-option').on('click', function () {
      $('#first-option a').html($(this).html());
      $('#first-option').removeClass('first-option-opened');
      $('.select-option').removeClass('select-option-opened');
      $('#performance-filter-list').removeClass('show');

      currentPage = 1;
      clickedOption = $(this).data('title');

      $('.line-container').hide();

      $('.gallery').each(function () {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      });

      $('.line-container').each(function () {
        if ($(this).data('title') === clickedOption) {
          $(this).fadeIn();
          $(this)
            .children('.gallery')
            .slick({
              lazyLoad: 'ondemand',
              centerMode: false,
              arrows: true,
              slidesToShow: 1,
              dots: true,
              prevArrow:
                '<button class="slick-prev red" aria-label="Previous" type="button"></button>',
              nextArrow:
                '<button class="slick-next red" aria-label="Next" type="button"></button>',
              responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                  },
                },
              ],
            });
        }
      });

      renderProducts(clickedOption, 1);
    });

    $btnLoadMore.on('click', function () {
      renderProducts(clickedOption, ++currentPage);
    });
  };

  const renderCarousels = () => {
    $('.gallery:first').slick({
      lazyLoad: 'ondemand',
      centerMode: false,
      arrows: true,
      slidesToShow: 1,
      dots: false,
      prevArrow:
        '<button class="slick-prev red" aria-label="Previous" type="button"></button>',
      nextArrow:
        '<button class="slick-next red" aria-label="Next" type="button"></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  };

  const getProductsLineByTitle = (title) => {
    return PRODUCTS_LINE_JSON.find((line) => line.title === title) || {};
  };

  const loadingAction = (action) => {
    if (action === 'show') {
      $btnLoadMore.hide();
      return $loading.show();
    }

    $btnLoadMore.show();
    $loading.hide();
  };

  const renderProducts = async (title, page = 1) => {
    const promises = [];
    const productsHTML = [];
    const productsLine = getProductsLineByTitle(title);
    const $lineContainer = $(`.line-container[data-title="${title}"]`);
    const $productsList = $lineContainer.find('.products-list');
    const products = productsLine.products_relationship || [];

    loadingAction('show');

    const start = (page - 1) * PRODUCTS_PER_PAGE;
    const end = start + PRODUCTS_PER_PAGE;

    for (let i = start; i < end; i++) {
      const product = products[i];

      if (!product) break;

      promises.push(
        new Promise((resolve, reject) => {
          $.ajax({
            url: CONFIGS_URLS.baseApiUrl + `/products/${product}`,
            success: (response) => {
              resolve(response);
            },
            error: (error) => {
              reject(error);
            },
          });
        })
      );
    }

    const responses = await Promise.allSettled(promises);
    const filteredResponses = responses
      .filter((response) => response.status === 'fulfilled')
      .map((item) => item.value);

    for (let i = 0; i < filteredResponses.length; i++) {
      const product = filteredResponses[i];
      const classes = 'col-xs-6 col-sm-6 col-md-4 product-thumb--black hide';
      const thumbnail =
        product.images && product.images.thumbnail
          ? product.images.thumbnail
          : '';

      const packshot =
        product.images && product.images.packshot
          ? product.images.packshot
          : '';

      const tobuy =
        product.acf.hash !== 'N/A'
          ? `${product.acf.hash}-${product.acf.ean}`
          : '';
      
      const link_to_buy =
      product.acf && product.acf.link !== undefined
        ? `${product.acf.link}`
        : '';

      if (link_to_buy && link_to_buy !== '' && link_to_buy !== undefined) {
        productsHTML.push(
          productThumbTemplateHTML
            .replace(/{{title}}/g, product.title.rendered)
            .replace(/{{link}}/g, product.link)
            .replace(/{{img}}/g, thumbnail)
            .replace(/{{imgProduct}}/g, packshot)
            .replace(/{{classes}}/g, `${classes} ${!thumbnail ? 'packshot' : ''}`)
            .replace(/{{trackingEvent}}/g, 'click-products-list')
            .replace(
              /{{trackingData}}/g,
              '{"item_name": "' + product.title.rendered + '"}'
            )
            .replace(`<button type="button" data-tobuy-modal="open" data-tobuy-hash="{{tobuy}}" class="product-thumb-buy__btn">Compre já</button>`, '')
            .replace('</a>', `</a><a href="${link_to_buy}" target="_blank"><button class="product-thumb-buy__btn">Compre já</button></a>`)
        );
      } else {
        productsHTML.push(
          productThumbTemplateHTML
            .replace(/{{title}}/g, product.title.rendered)
            .replace(/{{link}}/g, product.link)
            .replace(/{{img}}/g, thumbnail)
            .replace(/{{imgProduct}}/g, packshot)
            .replace(/{{tobuy}}/g, tobuy)
            .replace(/{{classes}}/g, `${classes} ${!thumbnail ? 'packshot' : ''}`)
            .replace(/{{trackingEvent}}/g, 'click-products-list')
            .replace(
              /{{trackingData}}/g,
              '{"item_name": "' + product.title.rendered + '"}'
            )
        );
      }
    }

    productsHTML.push('<div class="cf"></div>');

    loadingAction('hide');

    // hide load more button
    if (end >= products.length) {
      $btnLoadMore.hide();
    }

    $productsList.find('.cf').remove();

    page === 1
      ? $productsList.html(productsHTML.join(''))
      : $productsList.append(productsHTML.join(''));

    $productsList.find('.product-thumb').each(function () {
      const $images = $(this).find('img');
      const tobuy = $(this).data('tobuy');

      if (!tobuy) {
        $(this).find('[data-tobuy-hash]').remove();
      }

      $images.each(function () {
        if (!$(this).attr('src') && !$(this).attr('data-src')) {
          $(this).closest('.product-thumb--image--hover').length
            ? $(this).closest('.product-thumb--image--hover').remove()
            : $(this).remove();
        }
      });
    });

    $('.lazy').Lazy({
      scrollDirection: 'vertical',
      effect: 'fadeIn',
      visibleOnly: true,
    });
  };

  initialize();
  renderProducts(clickedOption);
});
